import { useForm } from "react-hook-form";
import { useMutation } from "@tanstack/react-query";
import { NewsletterService } from "../../services/newsletter.service";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

type NewsletterFormData = {
  email: string;
};

export const NewsletterCTA = () => {
  const { register, handleSubmit, reset } = useForm<NewsletterFormData>();
  const navigate = useNavigate();

  const { mutate, isPending, isSuccess } = useMutation({
    mutationFn: NewsletterService.subscribe,
    onSuccess: () => {
      toast.success("Subscribed successfully!");
      reset();
    },
    onError: (error: Error) => {
      toast.error(error.message);
    },
  });

  const onSubmit = async (data: NewsletterFormData) => {
    await mutate(data);
  };

  return (
    <div className="w-full py-[80px] sixm:py-[60px] bg-[#101828]">
      <div className="max-content">
        <div className="container">
          <div className="flex items-center gap-[32px] sixm:flex-col">
            <div className="w-[53%] sixm:w-full">
              <h3 className="text-[40px] sixm:text-[24px] font-satoshi text-white leading-[48px] sixm:leading-[32px] sixm:-tracking-normal -tracking-[2%] font-[900]">
                Stay in the know
              </h3>
              <p className="mt-[20px] sixm:mt-[16px] sixm:text-[16px] font-satoshi text-[#E9D7FE] font-[400] text-[20px] leading-[30px] sixm:leading-[24px]">
                It’s full of product updates, industry trends and insights
                delivered straight to your inbox
              </p>
            </div>

            <div className="w-[47%] sixm:w-full">
              {isSuccess ? (
                <div className="flex justify-center items-center gap-2 bg-green-50 p-4 rounded-lg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6 text-green-500"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                  <p className="text-green-800 font-medium">
                    Thank you for subscribing!
                  </p>
                </div>
              ) : (
                <form
                  onSubmit={handleSubmit(onSubmit)}
                  className="w-full flex flex-col gap-[16px] flex-col"
                >
                  <div className="w-full flex gap-[24px] sixm:flex-col">
                    <input
                      type="email"
                      {...register("email", { required: true })}
                      placeholder="Enter your email"
                      className="w-[75%] sixm:w-full px-[14px] py-[12px] border-[1px] border-[#D0D5DD] bg-white rounded-[8px] focus:outline-none"
                      disabled={isPending}
                      required
                    />
                    <p className="sixm:block hidden -mt-[10px]  font-[400] font-sans text-[14px] leading-[20px] text-[#E9D7FE]">
                      We care about your data in our{" "}
                      <span
                        onClick={() => navigate("/privacy-policy")}
                        className="underline cursor-pointer"
                      >
                        privacy policy
                      </span>
                      .
                    </p>
                    <button
                      type="submit"
                      className="w-[25%] sixm:w-full bg-[#175CD3] text-white py-[12px] px-[18px] rounded-[8px] hover:bg-blue-700 transition duration-200"
                      disabled={isPending}
                    >
                      {isPending ? "Subscribing..." : "Subscribe"}
                    </button>
                  </div>
                  <p className="sixm:hidden mt-[6px] font-[400] font-sans text-[14px] leading-[20px] text-[#E9D7FE]">
                    We care about your data in our{" "}
                    <span
                      onClick={() => navigate("/privacy-policy")}
                      className="underline cursor-pointer"
                    >
                      privacy policy
                    </span>
                    .
                  </p>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
